import * as yup from 'yup'
import dayjs from 'dayjs'

export const validationSchema = yup.object({
  display_name: yup.string().required('This field cannot be left blank'),
  bio: yup.string().max(80, 'Max length 80'),
  timezone: yup.string(),
  phone: yup.string(),
  role: yup.string(),
  location: yup.string(),
  pronouns: yup.string(),
  twitter_handle: yup.string(),
  team: yup.string(),
  birthday: yup.string().test('is-date', 'Not a valid date', (value) => dayjs(value).isValid()),
  joined_date: yup.string().test('is-date', 'Not a valid date', (value) => dayjs(value).isValid()),
})
